import useUniversalStore from "store/universalStore";
import { sendWAReminder } from "utils";

const ReminderAlert = (props) => {
  const { account, closeReminderAlert } = props;
  const userBasic = useUniversalStore(state => state.userBasic);

  const sendReminder = async () => {
    sendWAReminder(account, userBasic?.business?.name);
  };

  return (
    <div>
      <div className="alert bg-white p-4" role="alert" style={{ marginTop: "-200px" }}>
        <div className="text-center">
          <h2>Payment Overdue !!</h2>
          <hr />
        </div>
        <br />
        <div className="d-flex justify-content-center align-items-center">
          <div className="btn btn-secondary me-3 p-3" onClick={closeReminderAlert}>
            Close
          </div>
          <div onClick={sendReminder} className="btn btn-app border-app p-3">
            Send Reminder
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderAlert;